export default "<ion-title color=\"hauptcolor\" (click)=\"goToHome()\">\n  perspektiv<strong>wechsel</strong>\n</ion-title>"